<i class="fa" :class="{ 'fa-check-square-o': checked, 'fa-square-o': !checked, ...sizeObject }"></i>